import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Typography,
  TablePagination,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Exam } from "../interface";
import { HiOutlineDotsVertical } from "react-icons/hi";
import {
  formatCreatedAt,
  formatDescription,
  formatDuration,
} from "../utils/format";

import "../assets/css/Practice.css";
import dayjs, { Dayjs } from "dayjs";
import {
  createExam,
  createExamReading,
  deleteExam,
  getDetailExam,
  getListQuestion,
  updateExam,
  updateExamReading,
} from "../service";
import CustomSnackbar from "components/snackbar";
import CreateExamModal from "./Modal/ModalCreateExamWTMedia";
import EditExamModal from "./Modal/ModalEditExamWTMedia";
import duration from "dayjs/plugin/duration";
import ListWriting from "./Writing/ListQuestions";
dayjs.extend(duration);
interface TabWritingProps {
  exams: Exam[];
  fetchExams: any;
}

const TabWriting: React.FC<TabWritingProps> = ({ exams, fetchExams }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openCreate, setOpenCreate] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [currentExamId, setCurrentExamId] = useState<string>("");
  const [selectedExam, setSelectedExam] = useState<any>(null);
  const [selectedTime, setSelectedTime] = useState<Dayjs | null>(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [formattedMilliseconds, setFormattedMilliseconds] = useState<
    number | null
  >(null);
  const [startTime, setStartTime] = useState<Dayjs | null>(null);
  const [endTime, setEndTime] = useState<Dayjs | null>(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
    "success"
  );
  const [pass, setPass] = useState("");

  const [loadingDetail, setLoadingDetail] = useState(false);
  const [selectedDetailExam, setSelectedDetailExam] = useState<any>(null);
  const [questions, setQuestions] = useState<any[]>([]);
  const [isDetailView, setIsDetailView] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [groupedQuestions, setGroupedQuestions] = useState([]);
  const [showPassword, setShowPassword] = useState(!!pass);

  const handleClick = (event: React.MouseEvent<HTMLElement>, exam: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedExam(exam);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedExam(null);
  };

  const handleTimeChange = (newValue: Dayjs | null) => {
    setSelectedTime(newValue);
    if (newValue) {
      const hours = newValue.hour();
      const minutes = newValue.minute();
      const totalMilliseconds = hours * 3600000 + minutes * 60000;
      setFormattedMilliseconds(totalMilliseconds);
    }
  };

  const handleOpenCreate = () => {
    setTitle("");
    setPass("");
    setDescription("");
    setSelectedTime(null);
    setStartTime(null);
    setEndTime(null);
    setFormattedMilliseconds(null);
    setOpenCreate(true);
  };

  const handleOpenUpdate = (exam: any) => {
    setCurrentExamId(exam._id);
    setTitle(exam.title);
    setPass(!!exam.pass ? exam.pass : "");
    setShowPassword(!!exam.pass);
    setDescription(exam.description);
    const durationTime = dayjs.duration(exam.duration_time);
    setSelectedTime(
      dayjs().hour(durationTime.hours()).minute(durationTime.minutes())
    );
    setFormattedMilliseconds(exam.duration_time);
    setStartTime(dayjs(exam.start_time));
    setEndTime(dayjs(exam.end_time));
    setOpenUpdate(true);
  };

  const handleCloseCreate = () => setOpenCreate(false);

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const paginatedExams = exams.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const fetchQuestions = async (testId: string) => {
    try {
      const response = await getListQuestion(testId);
      setQuestions(response);
    } catch (error) {
      console.error("Failed to fetch questions:", error);
    }
  };

  const groupQuestions = (questions: any[]) => {
    const contentQuestions = questions.filter((q) => q.content);
    const answersByParentId = questions.reduce(
      (acc: Record<string, number>, curr) => {
        if (curr.parent_id) {
          acc[curr.parent_id] = (acc[curr.parent_id] || 0) + 1;
        }
        return acc;
      },
      {}
    );

    const grouped = contentQuestions.map((q) => ({
      ...q,
      answerCount: answersByParentId[q._id] || 0,
    }));

    setGroupedQuestions(grouped);
  };

  const handleDetailClick = async (examId: string) => {
    setLoadingDetail(true);
    try {
      const examResponse = await getDetailExam(examId);
      setSelectedDetailExam(examResponse.data);
      await fetchQuestions(examId);
      groupQuestions(questions);
      setIsDetailView(true);
    } catch (error) {
      console.error("Failed to fetch exam details:", error);
    } finally {
      setLoadingDetail(false);
    }
  };

  useEffect(() => {
    groupQuestions(questions);
  }, [questions]);

  const handleUpdateQuestions = async () => {
    await fetchQuestions(selectedDetailExam.test_id);
  };

  const handleCreateExam = async () => {
    if (
      !title ||
      !description ||
      !formattedMilliseconds ||
      !startTime ||
      !endTime
    ) {
      setSnackbarMessage("Vui lòng điền đầy đủ thông tin!");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    try {
      const response = await createExamReading(
        title,
        pass?.trim() ? pass : undefined,
        description,
        formattedMilliseconds,
        startTime.toISOString(),
        endTime.toISOString(),
        "writing"
      );
      await fetchExams();
      setSnackbarMessage("Tạo bài thi thành công!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setOpenCreate(false);
    } catch (error) {
      setSnackbarMessage("Không thể tạo bài thi, vui lòng thử lại.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleBackToList = () => {
    setIsDetailView(false);
    setSelectedDetailExam(null);
  };

  const handleUpdateExam = async () => {
    try {
      await updateExamReading(
        currentExamId,
        title,
        showPassword ? pass : "",
        description,
        formattedMilliseconds,
        startTime?.toISOString() ?? "",
        endTime?.toISOString() ?? "",
        "writing"
      );
      await fetchExams();
      setSnackbarMessage("Cập nhật bài thi thành công!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      setOpenUpdate(false);
    } catch (error) {
      setSnackbarMessage("Không thể cập nhật bài thi, vui lòng thử lại.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleDelete = async () => {
    if (selectedExam) {
      try {
        await deleteExam(selectedExam._id);
        setSnackbarMessage(`Đã xóa bài thi: ${selectedExam.title}`);
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        await fetchExams();
      } catch (error) {
        alert("Không thể xóa bài thi, vui lòng thử lại.");
        setSnackbarMessage("Không thể xóa bài thi, vui lòng thử lại.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    }
  };

  return (
    <>
      <Backdrop
        open={loadingDetail}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {isDetailView ? (
        <ListWriting
          selectedDetailExam={selectedDetailExam}
          groupedQuestions={groupedQuestions}
          handleBackToList={handleBackToList}
          dataQuestions={fetchQuestions}
        />
      ) : (
        <Box>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{ mb: 2, p: 1 }}
          >
            <Typography variant="body1" fontWeight={550} fontSize={20}>
              Danh sách bài thi
            </Typography>
            <Button
              className="save_exam"
              variant="contained"
              onClick={handleOpenCreate}
              sx={{
                border: "1px solid #B32519 !important",
                bgcolor: "#B32519 !important",
                "&:hover": {
                  bgcolor: "#B32519 !important",
                  border: "1px solid #B32519 !important",
                },
              }}
            >
              Tạo mới
            </Button>
          </Stack>
          {exams.length > 0 ? (
            <TableContainer>
              <Table sx={{ minWidth: 650 }} aria-label="listening exams table">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <strong>Tên và Mô tả</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Thể loại</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Thời gian</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Ngày tạo</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Hành động</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedExams.map((exam) => (
                    <TableRow key={exam?._id}>
                      <TableCell>
                        <Typography variant="body1">{exam?.title}</Typography>
                        <Typography variant="body2" color="text.secondary">
                          {formatDescription(exam?.description)}
                        </Typography>
                      </TableCell>
                      <TableCell>{exam?.type}</TableCell>
                      <TableCell>
                        {formatDuration(exam?.duration_time)}
                      </TableCell>
                      <TableCell>{formatCreatedAt(exam?.createdAt)}</TableCell>
                      <TableCell>
                        <IconButton onClick={(e) => handleClick(e, exam)}>
                          <HiOutlineDotsVertical />
                        </IconButton>
                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl)}
                          onClose={handleClose}
                        >
                          <MenuItem
                            onClick={() => {
                              handleClose();
                              handleDetailClick(selectedExam?._id);
                            }}
                          >
                            Chi tiết
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              handleClose();
                              handleOpenUpdate(selectedExam);
                            }}
                          >
                            Chỉnh sửa
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              handleClose();
                              handleDelete();
                            }}
                          >
                            Xóa
                          </MenuItem>
                        </Menu>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <TablePagination
                component="div"
                count={exams.length}
                page={page}
                onPageChange={(event, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(event) => {
                  setRowsPerPage(parseInt(event.target.value, 10));
                  setPage(0);
                }}
                rowsPerPageOptions={[5, 10, 25]}
              />
            </TableContainer>
          ) : (
            <Typography>Không có bài Listening nào.</Typography>
          )}
          <CreateExamModal
            pass={pass}
            setPass={setPass}
            open={openCreate}
            onClose={handleCloseCreate}
            title={title}
            setTitle={setTitle}
            description={description}
            setDescription={setDescription}
            selectedTime={selectedTime}
            setSelectedTime={setSelectedTime}
            startTime={startTime}
            setStartTime={setStartTime}
            endTime={endTime}
            setEndTime={setEndTime}
            onSubmit={handleCreateExam}
            handleTimeChange={handleTimeChange}
          />

          <EditExamModal
            pass={pass}
            setPass={setPass}
            showPassword={showPassword}
            setShowPassword={setShowPassword}
            open={openUpdate}
            onClose={() => setOpenUpdate(false)}
            _id={currentExamId}
            title={title}
            setTitle={setTitle}
            description={description}
            setDescription={setDescription}
            selectedTime={selectedTime}
            setSelectedTime={setSelectedTime}
            startTime={startTime}
            setStartTime={setStartTime}
            endTime={endTime}
            setEndTime={setEndTime}
            onSubmit={handleUpdateExam}
            handleTimeChange={handleTimeChange}
          />

          <CustomSnackbar
            open={snackbarOpen}
            message={snackbarMessage}
            severity={snackbarSeverity}
            onClose={handleSnackbarClose}
          />
        </Box>
      )}
    </>
  );
};

export default TabWriting;
